import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { DeleteDialog } from "../components";
import { routes } from "utilities/routing/generatedRoutes";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";
import { useOpenNewFlightSidePanel } from "components/SidePanel/Flight/NewFlightSidePanel";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  flightId: number
}

const FlightOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
  const [isCopying, setIsCopying] = React.useState<boolean>(false);

  const onDelete = async () => {
    await window.CoreApi.Flight.DeleteFlight({ flightId: props.flightId });
    window.location.href = props.listUrl;
  };

  const onCopy = async () => {
    const res = await window.CoreApi.Flight.CopyFlight({ flightId: props.flightId });
    return res.data;
  };
  const openNewFlightSidePanel = useOpenNewFlightSidePanel();


  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        {
          text: RESX.Flight.AddSegment,
          visible: site.permissions.flight.canCreate,
          onClick: () => openNewFlightSidePanel(props.flightId)
        },
        {
          href: props.listUrl,
          text: RESX.Buttons.ListView,
          visible: true
        }, {
          text: RESX.Buttons.btnCopy,
          onClick: () => { setIsCopying(true); },
          visible: site.permissions.flight.canCreate,
        }, {
          onClick: () => { setIsDeleting(true); },
          text: RESX.Buttons.btnDelete,
          visible: site.permissions.flight.canCreate,
        }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <ConfirmCopyModal
      isOpen={isCopying}
      apiCall={onCopy}
      onClose={() => { setIsCopying(false); }}
      onSuccess={(itemId) => window.location.href = routes.flight_Detail(itemId).absolute}
    />
  </>;
};

export default FlightOptionsPanel;